module.exports = __webpack_public_path__ + "static/media/06-messages.67f7ad8b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/how-courses-work/06-messages.jpg
// module id = 375
// module chunks = 0